import { render, staticRenderFns } from "./NgWord.vue?vue&type=template&id=224b1975&scoped=true&"
import script from "./NgWord.vue?vue&type=script&lang=js&"
export * from "./NgWord.vue?vue&type=script&lang=js&"
import style0 from "./NgWord.vue?vue&type=style&index=0&id=224b1975&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224b1975",
  null
  
)

export default component.exports